export const LoaderNoStarted = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12.6947" cy="6.37318" r="1.33194" fill="#004597" />
    <circle cx="6.47903" cy="12.1449" r="1.33194" fill="#004597" />
    <circle cx="18.7327" cy="12.1449" r="1.33194" fill="#004597" />
    <circle cx="12.6947" cy="18.6268" r="1.33194" fill="#004597" />
    <circle cx="8.25497" cy="8.1491" r="1.33194" fill="#004597" />
    <circle cx="8.25497" cy="16.5847" r="1.33194" fill="#004597" />
    <circle cx="16.9568" cy="8.1491" r="1.33194" fill="#004597" />
    <circle cx="16.9568" cy="16.5847" r="1.33194" fill="#004597" />
  </svg>
);
